import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { OVIDProvider } from '@outdoor-voices/ui/dist/utils/customer/OVIDProvider';
import { SHOW_OVID_MODAL } from '@outdoor-voices/ui/dist/config/constants';
import { useEffect, useState } from 'react';
import AccountNav from '@outdoor-voices/ui/dist/components/AccountNav';
import cc from 'classcat';
import PropTypes from 'prop-types';
import { COOKIE_DOMAIN, JWT_COOKIE_NAME } from '../../customers/constants';
import { OV_ID_URL } from '../../../config/theme';
import ConfirmDelete from './ConfirmDelete';
import css from './WishList.module.scss';
import Item from './Item';
import Overlay from '../../../components/Overlay'; // import Recommendations from './Recommendations';

import ShareButton from './ShareButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var NoItems = function NoItems() {
  return /*#__PURE__*/_jsx("p", {
    className: css.noItems,
    children: "Items added to your wish list will be saved here."
  });
};

var LoggedIn = function LoggedIn(_ref) {
  var wishList = _ref.wishList;

  var _useState = useState(wishList.items),
      _useState2 = _slicedToArray(_useState, 2),
      items = _useState2[0],
      setItems = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      deleting = _useState4[0],
      setDeleting = _useState4[1];

  var onDelete = function onDelete(_ref2) {
    var id = _ref2.id,
        colorway = _ref2.colorway;
    setDeleting({
      id: id,
      colorway: colorway
    });
  };

  var onDeleteCancel = function onDeleteCancel() {
    setDeleting(null);
  };

  var onDeleted = function onDeleted() {
    var newItems = items.filter(function (item) {
      return item.id !== deleting.id;
    });
    setItems(newItems);
    setDeleting(null);
  };

  var deletingOn = deleting !== null;
  useEffect(function () {
    var _window = window,
        history = _window.history,
        location = _window.location;
    var urlParams = new URLSearchParams(location.search);
    urlParams.set('id', wishList.id);
    history.replaceState({}, '', "".concat(location.pathname.split('//').join('/'), "?").concat(decodeURIComponent(urlParams.toString())));
  }, [wishList.id]);
  return /*#__PURE__*/_jsxs("div", {
    className: css.wishList,
    children: [/*#__PURE__*/_jsx("div", {
      className: css.accountNav,
      children: /*#__PURE__*/_jsx(OVIDProvider, {
        domain: COOKIE_DOMAIN,
        name: JWT_COOKIE_NAME,
        url: OV_ID_URL,
        children: /*#__PURE__*/_jsx(AccountNav, {
          ovIDURL: OV_ID_URL,
          shopifyURL: "/"
        })
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: css.content,
      children: [/*#__PURE__*/_jsxs("header", {
        className: css.header,
        children: [/*#__PURE__*/_jsx("h1", {
          className: css.title,
          children: "Your Wish List"
        }), /*#__PURE__*/_jsx(ShareButton, {
          id: wishList.id
        })]
      }), items.length < 1 && /*#__PURE__*/_jsx(NoItems, {}), items.length > 0 && /*#__PURE__*/_jsx("div", {
        className: css.main,
        children: /*#__PURE__*/_jsx("ul", {
          className: css.list,
          children: items.map(function (item) {
            return /*#__PURE__*/_jsx("li", {
              className: css.listItem,
              children: /*#__PURE__*/_jsx(Item, {
                emsColorwayGid: item.emsColorwayGid,
                emsProductGid: item.emsProductGid,
                id: item.id,
                onDelete: onDelete
              })
            }, item.id);
          })
        })
      }), items.length > 0 && /*#__PURE__*/_jsx(Overlay // Don't add aria-labels until corresponding tags are in the DOM.
      , {
        ariaDescribedBy: deletingOn ? 'confirm-remove-description' : null,
        ariaLabelledBy: deletingOn ? 'confirm-remove-title' : null,
        label: "Confirm removing item".concat(items.length === 1 ? '' : 's', " from your wish list"),
        on: deletingOn,
        onHide: onDeleteCancel,
        children: /*#__PURE__*/_jsx(ConfirmDelete, {
          colorway: deleting === null || deleting === void 0 ? void 0 : deleting.colorway,
          id: deleting === null || deleting === void 0 ? void 0 : deleting.id,
          on: deletingOn,
          onCancel: onDeleteCancel,
          onDeleted: onDeleted
        })
      })]
    })]
  });
};

LoggedIn.propTypes = {
  wishList: PropTypes.shape({
    id: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({}))
  })
};

var Viewing = function Viewing(_ref3) {
  var wishList = _ref3.wishList;
  var id = wishList.id,
      items = wishList.items,
      userFirstName = wishList.userFirstName;
  return /*#__PURE__*/_jsxs("div", {
    className: cc([css.viewing, css.content]),
    children: [/*#__PURE__*/_jsxs("header", {
      className: css.header,
      children: [/*#__PURE__*/_jsxs("h1", {
        className: css.title,
        children: [userFirstName && /*#__PURE__*/_jsxs(_Fragment, {
          children: [userFirstName, "'s"]
        }), " Wish List"]
      }), /*#__PURE__*/_jsx(ShareButton, {
        centered: true,
        id: id
      })]
    }), items.length < 1 && /*#__PURE__*/_jsx("p", {
      className: css.noItems,
      children: "This wish list does not have any items yet."
    }), items.length > 0 && /*#__PURE__*/_jsx("div", {
      className: css.main,
      children: /*#__PURE__*/_jsx("ul", {
        className: css.list,
        children: items.map(function (item) {
          return /*#__PURE__*/_jsx("li", {
            className: css.listItem,
            children: /*#__PURE__*/_jsx(Item, {
              emsColorwayGid: item.emsColorwayGid,
              id: item.id,
              onDelete: false
            })
          }, item.id);
        })
      })
    })]
  });
};

Viewing.propTypes = {
  wishList: PropTypes.shape({
    id: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({})),
    isOwner: PropTypes.bool,
    userFirstName: PropTypes.string
  }).isRequired
};

var LoggedOut = function LoggedOut() {
  var onLogin = function onLogin(event) {
    if (event.metaKey || event.ctrlKey) {
      return;
    }

    event.preventDefault();
    var modalEvent = new CustomEvent(SHOW_OVID_MODAL, {
      detail: {}
    });
    window.dispatchEvent(modalEvent);
  };

  var onSignUp = function onSignUp(event) {
    if (event.metaKey || event.ctrlKey) {
      return;
    }

    event.preventDefault();
    var modalEvent = new CustomEvent(SHOW_OVID_MODAL, {
      detail: {
        type: 'REGISTER'
      }
    });
    window.dispatchEvent(modalEvent);
  };

  useEffect(function () {
    var handleMessage = function handleMessage(_ref4) {
      var data = _ref4.data;

      if (!data || typeof data !== 'string') {
        return;
      } // eslint-disable-next-line no-unused-vars


      var _data$split = data === null || data === void 0 ? void 0 : data.split('::'),
          _data$split2 = _slicedToArray(_data$split, 2),
          key = _data$split2[0],
          _ = _data$split2[1];

      if (key !== 'OVID') {
        return;
      }

      window.location.reload();
    };

    var message = 'message';
    window.addEventListener(message, handleMessage, false);
    return function () {
      window.removeEventListener(message, handleMessage);
    };
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    className: cc([css.loggedOut, css.content]),
    children: [/*#__PURE__*/_jsxs("header", {
      className: css.header,
      children: [/*#__PURE__*/_jsx("h1", {
        className: css.title,
        children: "Your Wish List"
      }), /*#__PURE__*/_jsxs("p", {
        className: css.subTitle,
        children: ["You must", ' ', /*#__PURE__*/_jsx("a", {
          href: "".concat(OV_ID_URL, "users/login?redirectTo=").concat(window.location.href),
          onClick: onLogin,
          children: "Sign In"
        }), ' ', "or", ' ', /*#__PURE__*/_jsx("a", {
          href: "".concat(OV_ID_URL, "users/register?redirectTo=").concat(window.location.href),
          onClick: onSignUp,
          children: "Create An Account"
        }), ' ', "to add items to your wish list."]
      })]
    }), /*#__PURE__*/_jsx(NoItems, {})]
  });
};

var WishList = function WishList(_ref5) {
  var loggedIn = _ref5.loggedIn,
      wishList = _ref5.wishList;

  if (loggedIn && wishList !== null && wishList !== void 0 && wishList.isOwner) {
    return /*#__PURE__*/_jsx(LoggedIn, {
      wishList: wishList
    });
  }

  if (wishList) {
    return /*#__PURE__*/_jsx(Viewing, {
      wishList: wishList
    });
  }

  return /*#__PURE__*/_jsx(LoggedOut, {});
};

WishList.propTypes = {
  loggedIn: PropTypes.bool,
  wishList: PropTypes.shape({
    isOwner: PropTypes.bool
  })
};
export default WishList;